<dku-bs-select
    [params]="selectParams"
    (modelChange)="selectItem($event)"
    [model]="selectedItem"
    [list]="selectableItems"
    [optionsAnnotations]="variableTypes"
    ngOptions="v as v.displayName disable when v.disabled for v in list"
    dataLiveSearch="true"
></dku-bs-select>
